import { MonitorDetailStatusOverview } from '../../../../domain/monitor/monitorDetailStatusOverview';
import { OnInit } from '@angular/core';
var MonitorInformationTileComponent = /** @class */ (function () {
    function MonitorInformationTileComponent() {
    }
    MonitorInformationTileComponent.prototype.ngOnInit = function () { };
    return MonitorInformationTileComponent;
}());
export { MonitorInformationTileComponent };
